import { IconProps } from "../../types/utils";

const Image = ({ color, dimension, ...props }: IconProps) => (
  <svg
    width={dimension || 32}
    height={dimension || 32}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M24.0002 5.33325H8.00016C6.52946 5.33325 5.3335 6.52922 5.3335 7.99992V23.9999C5.3335 25.4706 6.52946 26.6666 8.00016 26.6666H24.0002C25.4709 26.6666 26.6668 25.4706 26.6668 23.9999V7.99992C26.6668 6.52922 25.4709 5.33325 24.0002 5.33325ZM8.00016 7.11103H24.0002C24.4904 7.11103 24.8891 7.50968 24.8891 7.99992V14.2985L21.962 11.3714C21.6147 11.0244 21.0522 11.0244 20.705 11.3714L14.4446 17.6319L12.1842 15.3714C11.837 15.0244 11.2745 15.0244 10.9272 15.3714L7.11127 19.1874V7.99992C7.11127 7.50968 7.50993 7.11103 8.00016 7.11103ZM24.0002 24.8888H8.00016C7.50993 24.8888 7.11127 24.4902 7.11127 23.9999V21.7013L11.5557 17.2569L16.705 22.4057C16.8789 22.58 17.1058 22.6666 17.3335 22.6666C17.5611 22.6666 17.7881 22.58 17.962 22.4062C18.309 22.0589 18.309 21.4964 17.962 21.1492L15.7016 18.8888L21.3335 13.2573L24.8891 16.8129V23.9999C24.8891 24.4902 24.4904 24.8888 24.0002 24.8888Z"
      fill={color || "#242424"}
    />
    <path
      d="M12.4442 10.6664C12.4442 11.6482 11.6482 12.4442 10.6664 12.4442C9.68468 12.4442 8.88867 11.6482 8.88867 10.6664C8.88867 9.68468 9.68468 8.88867 10.6664 8.88867C11.6482 8.88867 12.4442 9.68468 12.4442 10.6664Z"
      fill={color || "#242424"}
    />
  </svg>
);

export default Image;
